const refreshFragments = {
  init() {
    function refresh_fragments() {
      console.log('fragments refreshed!');
      jQuery( document.body ).trigger( 'wc_fragment_refresh' );
    }

    jQuery('#vat_number').focusout(refresh_fragments());
  },
};

export default refreshFragments;



// WEBPACK FOOTER //
// ./scripts/modules/checkout-refresh-fragments.js